import { render, staticRenderFns } from "./TravelInfoBlock.vue?vue&type=template&id=37d93ebe&"
import script from "./TravelInfoBlock.vue?vue&type=script&lang=js&"
export * from "./TravelInfoBlock.vue?vue&type=script&lang=js&"
import style0 from "./TravelInfoBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VAppBar,VBtn,VCard,VChip,VIcon,VList,VListItem,VListItemTitle,VMenu,VSimpleTable,VSkeletonLoader,VSpacer,VToolbarTitle})


/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37d93ebe')) {
      api.createRecord('37d93ebe', component.options)
    } else {
      api.reload('37d93ebe', component.options)
    }
    module.hot.accept("./TravelInfoBlock.vue?vue&type=template&id=37d93ebe&", function () {
      api.rerender('37d93ebe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AccountPage/TravelInfoBlock/TravelInfoBlock.vue"
export default component.exports